export {default as GenerateQRCodePDF} from './generate-QR-pdf';
